import * as Yup from 'yup';

import { addressBlock } from 'common/helpers/yup-helpers';

export const rentersValidationSchema = () =>
  Yup.object().shape({
    people: Yup.array(
      Yup.object().shape({
        firstName: Yup.string().trim().required('First Name is required'),
        lastName: Yup.string().trim().required('Last Name is required')
      })
    ),
    rentersCoverage: Yup.object().shape({
      rentersLocation: addressBlock('Renters address')
    })
  });
